/**
 * ion-label
 * @author xierenyuan@qq.com
 */
import Label from './src/label';

Label.install = function(Vue) {
    Vue.component(Label.name, Label);
};

export default Label;


// WEBPACK FOOTER //
// ./src/components/label/index.js